import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import ReactDatetime from "react-datetime";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
} from "react-bootstrap"
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';



const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {

  const [swal, setSwal] = useAlert();

  const [scoreGroup, setScoreGroup] = useState([]);
  const fetchScoreGroup = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scores`, {
        params: { all: true }
      });

      setScoreGroup(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }else{
      event.preventDefault();
      onApplyChanges();
    }

    setValidated(true);

  };

  useEffect(() => {
    fetchScoreGroup();
    setValidated(false);
  }, []);

  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>Score Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="validationCustom01">
          <Form.Label>Score Group</Form.Label>
          <Form.Control as="select"
              name='SCORE_ID'
              value={row.SCORE_ID ?? ''}
              onChange={onChange}
              required
            >
              <option value=''>Select Group</option>
              {scoreGroup && scoreGroup.map((score, key) => (
                <option key={key}value={score.SCORE_ID}>
                  {score.SCORE_ID} - {score.SCORE_NAME}
                </option>
              ))}
          </Form.Control>
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="validationCustom02">
          <Form.Label>Index</Form.Label>
            <Form.Control
              name="SCORE_INDEX"
              value={row.SCORE_INDEX}
              required
              onChange={onChange}
            />
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="validationCustom04">
          <Form.Label>Description</Form.Label>
            <Form.Control
              name="SCORE_DESC"
              value={row.SCORE_DESC}
              required
              onChange={onChange}
            />
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="validationCustom03">
          <Form.Label>Status</Form.Label>
          <Form.Control as="select"
            name="SCORE_STATUS"
            value={row.SCORE_STATUS ?? ''}
            onChange={onChange}
            required
          >
            <option value=''>Select Status...</option>
            <option value="1">PASS</option>
            <option value="0">FAIL</option>
            <option value="2">NA</option>

          </Form.Control>
          <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
        </Form.Group>


      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" type="submit" >Save</Button>
      </Modal.Footer>
      </Form>
    </Modal>
  )
};

export default Popup;